import ThangSelection from "./ThangSelection";

export default ThangSelection